<div appTheme>
    <div class="modal-box scrolling">
        <div class="modal-box-container main-container">
            <h1>Change Email</h1>
            <div class="col-sm-12">
                <div>
                    <p>Press the button below to reset your email.</p>
                    <br>
                    <button class="submit-button button-large" id="resetBtn" (click)="onResetEmail()" [disabled]="operationSuccess">
                        Reset Email <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
                <br><br>
                <div *ngIf="message"  [ngClass]="{'success-message': isSuccess, 'failure-message': !isSuccess}" [innerHtml]="message|innerHtmlStyle"></div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Resetting Email...'" [size]="'fa-5x'"></app-loading>
</div>
